<template>
  <v-container pa-0 v-if="!showForm">
    <v-row class="mt-n9">
      <v-col>
        <v-btn text small color="primary" @click="$router.push({ path: prevPath})">
          <v-icon>mdi-arrow-left-circle</v-icon> <span class="ml-2">Назад к списку заявок</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="ml-3">
      <div class='headline' v-if="ticket['ticket_type']['id'] != 5 && ticket['ticket_type']['id'] != 6">Заявка № {{ ticket['code'] }}</div>
      <div class='headline' v-else>Обращение № {{ ticket['code'] }}</div>
    </v-row>
    <v-row v-if="ticket['ticket_type']['id'] != 5 && ticket['ticket_type']['id'] != 6">
      <v-col>
        <v-card class="mt-4 col-12" elevation="1">
          <a @click="showForm = true">
            <v-icon v-html="'edit'" class="mr-2" />Просмотр <span v-if="!isFinished">/ редактирование</span></a><a class="ml-4" @click="saveFile">
            <v-icon v-html="'save'" class="mr-2" />Скачать файл заявки</a>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="ticket.need_signature && !isFileAttached">
      <v-col>
        <v-alert border="left" color="orange" type="warning" dense>
          Внимание! Необходимо распечатать файл заявки, поставить подпись и загрузить отсканированный файл в чат
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols=12 sm=4>
        <v-card elevation="0" outlined>
          <v-row justify="center" class='mb-3'>
            <v-col>
              <div class="round-icon-back">
                <font-awesome-icon class='round-icon' :icon="['fas', 'file-alt']" />
              </div>
            </v-col>
          </v-row>
          <v-list subheader three-line>
            <v-subheader>Детали заявки</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Номер</v-list-item-title>
                <v-list-item-subtitle>{{ ticket['code'] }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Тип</v-list-item-title>
                <v-list-item-subtitle>{{ typeName }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <div v-if="ticket['ticket_type']['id'] == 5">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Ф.И.О.</v-list-item-title>
                  <v-list-item-subtitle>{{ ticket['fields'].name }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Телефон</v-list-item-title>
                  <v-list-item-subtitle>{{ ticket['fields'].phone == 'None' ? '-' : ticket['fields'].phone }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Адрес</v-list-item-title>
                  <v-list-item-subtitle>{{ ticket['fields'].address == 'None' ? '-' : ticket['fields'].address }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Номер л/с</v-list-item-title>
                  <v-list-item-subtitle>{{ ticket['fields'].account == 'None' ? '-' : ticket['fields'].account }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
            <div v-if="ticket['ticket_type']['id'] == 6">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Ф.И.О. лица, направившего уведомление</v-list-item-title>
                  <v-list-item-subtitle>{{ ticket['fields'].name }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Адрес фактического проживания</v-list-item-title>
                  <v-list-item-subtitle>{{ ticket['fields'].address == 'None' ? '-' : ticket['fields'].address }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Телефон лица, направившего уведомление</v-list-item-title>
                  <v-list-item-subtitle>{{ ticket['fields'].phone }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
            <v-list-item v-if="isOperator">
              <v-list-item-content>
                <v-list-item-title>E-mail заявителя</v-list-item-title>
                <v-list-item-subtitle>{{ ticket.user_email == 'None' ? '-' : ticket.user_email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Дата создания</v-list-item-title>
                <v-list-item-subtitle>{{ ticket['create_date'] }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Дата изменения</v-list-item-title>
                <v-list-item-subtitle>{{ ticket['edit_date'] }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Статус</v-list-item-title>
                <v-list-item-subtitle>
                  <v-select v-if="isOperator" :items="statuses" dense v-model="status" :disabled="isFinished && !isSuperuser || userRoles.includes('changing_status_not_allowed')"></v-select>
                  <span v-else>{{ ticket['status']['name'] }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <div v-if="isOperator">
              <div v-if="ticket['ticket_type']['id'] == 5">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Тип обращения</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-select :items="questionTypes" dense v-model="questionType" :disabled="isFinished"></v-select>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Назначена на</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-select :items="operators" dense v-model="operator" :disabled="isFinished"></v-select>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Тепловой район</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-autocomplete :items="heatRegions" dense v-model="heatRegion" :disabled="isFinished"></v-autocomplete>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="ticket['ticket_type']['id'] == 5">
                <v-list-item-content>
                  <v-list-item-title>Срок исполнения заявки</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-menu :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" v-model="isDateOpened">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="dateFormatted" @blur="expirationTime = parseDate(dateFormatted)" color="secondary" prepend-icon="event" readonly v-on="on" :disabled="isFinished"></v-text-field>
                      </template>
                      <v-date-picker v-model="expirationTime" color="secondary" locale="ru-ru" :min="today" @click:date="isDateOpened=false"></v-date-picker>
                    </v-menu>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-row align="center" justify="center">
                  <v-btn @click="saveTicket" color="primary" text :disabled="!hasChanges">Сохранить</v-btn>
                </v-row>
              </v-list-item>
            </div>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols=12 sm=8>
        <v-card elevation="1">
          <v-toolbar color="accent" dark elevation="0">
            <v-toolbar-title>Сообщения</v-toolbar-title>
          </v-toolbar>
          <v-list two-line>
            <template v-for="(msg, index) in messages">
              <v-list-item :key="msg.datetime + index">
                <v-list-item-icon v-if="!msg['is_user']">
                  <v-icon color="indigo">mdi-message-text</v-icon>
                </v-list-item-icon>
                <v-list-item-content :class="{ 'text-right': msg['is_user'] }">
                  <div class="text-subtitle-1 msg-text">{{ msg['text'] }}</div>
                  <div v-if="msg['files']">
                    <v-list-item-title v-for="(f, indx) in msg['files']" class="message-file" @click="downloadMessageFile(index, indx)">{{ f.name }}</v-list-item-title>
                  </div>
                  <v-list-item-subtitle>Добавлено {{ msg['datetime'] }} <span v-if="msg['user_login'] != ''"><span v-if="msg['is_user']"> пользователем</span><span v-else> оператором</span></span> {{msg['user_login']}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon v-if="msg['is_user']" class="ml-2">
                  <v-icon color="indigo">mdi-message-text</v-icon>
                </v-list-item-icon>
                <v-list-item-action v-if="isSuperuser">
                  <v-btn icon @click="deleteMsg(msg)">
                    <v-icon color="grey lighten-1">mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < messages.length" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card>
        <v-card class="mt-3 pl-2" elevation="1" v-if="!isFinished || isSuperuser">
          <v-form v-model="messageForm" ref="form">
            <v-textarea prepend-icon="mdi-comment" class="mx-2 mt-4 mb-n3 message-input" placeholder="Сообщение" v-model="message" rounded rows="7" :rules="[rules.required]"></v-textarea>
            <!--<v-divider></v-divider>-->
            <v-card-actions class="pb-0">
              <v-file-input dense multiple label="Прикрепить файл (макс. размер 10МБ)" class="pt-1" v-model="files" style="width: 180px" :rules="[rules.fileSize]"></v-file-input>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="saveMessage">
                Отправить
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
        <rating v-if="ticket['rating'] && ticket['ticket_type']['id'] != 5 && ticket['ticket_type']['id'] != 6" 
          :ticketId="ticketId" 
          :ticketRating="ticket['rating']['value']" 
          :ticketMessage="ticket['rating']['message']" 
          :ratingDate="ticket['rating']['date']"
          class="mt-3 pl-2">            
          </rating>
        <rating v-if="!isOperator && !ticket['rating'] && ticket['ticket_type']['id'] != 5 && ticket['ticket_type']['id'] != 6" 
          :ticketId="ticketId" 
          v-on:update:rating="ticket['rating']={'value': $event['value'], 'message': $event['message']}"
          class="mt-3 pl-2">            
          </rating>
      </v-col>
    </v-row>
    <request-dialog v-model="searchDialog" message="Выполняется запрос..." />
  </v-container>
  <v-container v-else pa-0>
    <v-row align="center" justify="center">
      <v-toolbar color="accent" dark max-width="794" v-if="!isIE">
        <v-btn class="mr-6 ml-1" dark icon @click="showForm=false">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title><span v-if="!isFinished">Редактирование заявки</span><span v-else>Просмотр заявки</span></v-toolbar-title>
      </v-toolbar>
      <div color="accent" dark max-width="794" v-else>
        <v-btn class="mr-6 ml-1 mb-2" icon color="accent" dark @click="showForm=false">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span v-if="!isFinished" class='headline'>Редактирование заявки</span><span v-else class='headline'>Просмотр заявки</span>
      </div>
    </v-row>
    <edit :ticketId="ticketId" :typeId="typeId" :ticketInfo="ticket" :isFinished="isFinished" :isOperator="isOperator"></edit>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { convertDate, parseDate, downloadFile, fileListToBase64, _base64ToArrayBuffer } from '@/utils'

export default {
  name: 'Ticket',

  props: {
    ticketId: {
      type: Number,
      default: undefined
    },
    typeId: {
      type: Number,
      default: undefined
    },
    isOperator: {
      type: Boolean,
      default: false
    }
  },

  components: {
    edit: () => import(
      '@/views/tickets/EditTicketView'
    ),
    rating: () => import(
      '@/components/base/Rating'
    )
  },

  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      if (!vm.isOperator) {
        const resp = await vm.$api.Account.getUserTickets(vm.userLogin)
        let userTickets = resp.data
        for (let t in userTickets) {
          if (userTickets[t].id == vm.ticketId) {
            next()
            return
          }
        }
        next(`/tickets`)
      }
    })
  },

  data: () => ({
    ticket: {
      'code': '',
      'status': '',
      'create_date': '',
      'edit_date': '',
      'ticket_type': '',
      'need_signature': false
    },
    searchInput: '',
    showForm: false,
    messages: [{
      'id': 0,
      'is_user': false,
      'text': 'Заявка создана',
      'datetime': '20.01.20 10:20',
      'files': []
    }],
    rules: {
      required: value => !!value || 'Обязательное поле',
      fileSize: function(v) {
        return (v.length == 0 || v.reduce(function(previousValue, currentValue, index, array) {
          return previousValue + currentValue.size
        }, 0) <= 10485760) || 'Размер файла превышает 10МБ'
      },
      days: value => value > 0 || 'Количество дней должно быть больше 0'
    },
    message: '',
    files: [],
    expirationTime: 30,
    searchDialog: false,
    messageForm: false,
    operators: [{ value: -1, text: 'Выберите сотрудника', disabled: true }],
    operator: -1,
    heatRegions: [{ value: -1, text: 'Выберите тепловой район', disabled: true }],
    heatRegion: -1,
    questionType: -1,
    status: -1,
    statuses: [{ value: -1, text: 'Выберите статус', disabled: true }],
    isDateOpened: false,
    dateFormatted: null
  }),

  computed: {
    ...mapGetters({
      userLogin: 'user/userLogin',
      userRoles: 'user/userRoles',
      ticketTypes: 'common/ticketTypes',
      questionTypes: 'common/questionTypes'
    }),
    hasChanges: function() {
      if (this.ticket['ticket_type']['id'] == 5) return this.ticket.status['id'] != this.status || this.ticket.operator != this.operator || this.ticket.heat_region != this.heatRegion || this.ticket.fields.question_type != this.questionType || this.ticket.expiration_time != this.expirationTime
      else return this.ticket.status['id'] != this.status || this.ticket.operator != this.operator || this.ticket.heat_region != this.heatRegion || this.ticket.expiration_time != this.expirationTime
    },
    isFinished: function() {
      return this.ticket.status['id'] == 7 || this.ticket.status['id'] == 6
    },
    isSuperuser: function() {
      return this.userRoles.includes('superuser')
    },
    isIE: function() {
      let ua = navigator.userAgent
      /* MSIE used to detect old browsers and Trident used to newer ones*/
      let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1
      return is_ie
    },
    isFileAttached: function() {
      for (let m in this.messages) {
        if (this.messages[m].is_user && this.messages[m].files.length != 0) return true
      }
      return false
    },
    today: () => { return new Date().toISOString().substr(0, 10) },
    typeName: function() {
      if (this.ticket['ticket_type']['id'] == 5 && this.ticket['fields']['question_type'] != 'None') {
        return `${this.ticket['ticket_type']['name']} - ${this.questionTypes[this.ticket['fields']['question_type']]['text']}`
      } else return this.ticket['ticket_type']['name']
    },
    prevPath: function() {
      if (!this.isOperator) return '/tickets/my_tickets/'
      else return `/tickets/tickets_by_type/${this.ticket['ticket_type']['id']}`
    }
  },
  watch: {
    expirationTime(val) {
      this.dateFormatted = convertDate(this.expirationTime)
    }
  },
  created: function() {
    this.getStatuses()
    this.getHeatRegions()
    if (this.isOperator) this.getOperators()
    this.getTicketInfo()
  },

  methods: {
    parseDate: parseDate,
    getTicketInfo: async function() {
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getTicketInfo(this.ticketId)
        this.ticket = resp.data
        this.ticket.need_signature = this.ticketTypes[this.ticket['ticket_type']['id']]['need_signature']
        this.messages = resp.data['messages']
        this.operator = resp.data['operator']
        this.status = resp.data['status']['id']
        this.expirationTime = parseDate(this.ticket.expiration_time)
        if (!this.userRoles.includes('superuser')) this.statuses = this.statuses.filter(status => status.value >= this.status || status.value == -1)
        this.heatRegion = resp.data['heat_region']
        if (this.ticket['ticket_type']['id'] == 5) this.questionType = this.ticket['fields']['question_type']
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        if (e.response.status == 401) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        let error = 'Не удалось получить информацию о заявке. Попробуйте повторить запрос позднее'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    deleteMsg: async function(item) {
      if (confirm('Удалить сообщение?')) {
        try {
          await this.$api.Account.delMessage(item.id)
          this.messages = this.messages.filter(obj => obj.id != item.id)
        } catch (e) {
          const err = e
          let error = 'Не удалось удалить сообщение'
          await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
          console.error(e)
        }
      }
    },
    getOperators: async function() {
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getOperators(this.typeId)
        for (let item in resp.data) { this.operators.push(resp.data[item]) }
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        if (e.response.status == 401) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        let error = 'Не удалось загрузить список операторов'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    getStatuses: async function() {
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getTicketStatuses()
        for (let item in resp.data) {
          if (this.typeId != 6 || [1, 3, 7].includes(resp.data[item]['value'])) this.statuses.push(resp.data[item])
        }
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        let error = 'Не удалось загрузить статусы заявки'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    getHeatRegions: async function() {
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getHeatRegions()
        for (let item in resp.data) { this.heatRegions.push(resp.data[item]) }
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        if (e.response.status == 401) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        let error = 'Не удалось загрузить список тепловых регионов'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    saveTicket: async function() {
      let ticketInfo = { 'ticket_id': this.ticketId, 'status': this.status, 'expiration_time': this.expirationTime, 'heat_region': this.heatRegion, 'operator': this.operator }
      if (this.ticket['ticket_type']['id'] == 5 && this.questionType != null) ticketInfo['question_type'] = { 'id': this.questionType, 'name': this.questionTypes[this.questionType]['text'] }
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.saveTicketInfo(ticketInfo)
        await this.$store.dispatch('notification/setSystemNotification', { message: 'Изменения сохранены', type: 'success' })
        this.ticket.status['id'] = this.status
        for (let s in this.statuses) {
          if (this.statuses[s].value == this.status) this.ticket.status['name'] = this.statuses[s].text
        }
        this.ticket.operator = this.operator
        if (this.ticket['ticket_type']['id'] == 5) this.ticket.fields.question_type = this.questionType
        this.ticket.heat_region = this.heatRegion
        let new_message = {
          'is_user': !this.isOperator,
          'text': resp.data
        }
        this.messages.push(new_message)
        this.searchDialog = false
        this.$router.push({ path: this.prevPath })
      } catch (e) {
        const err = e
        this.searchDialog = false
        if (e.response.status == 401 || e.response.status == 403) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        let error = 'Не удалось сохранить изменения'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    saveMessage: async function() {
      let isValid = this.$refs.form.validate()
      if (isValid) {
        this.searchDialog = true
        try {
          let fileArray = []
          let fileObjs = []
          if (this.files) {
            fileArray = await fileListToBase64(this.files)
            for (let i = 0; i < this.files.length; i++) fileObjs.push({ name: this.files[i].name, file: fileArray[i] })
          }
          let message_obj = { 'message': this.message, 'is_user': !this.isOperator, 'user_login': this.userLogin, 'files': fileObjs, 'ticket_id': this.ticketId }
          const resp = await this.$api.Account.saveMessage(message_obj)
          let new_message = resp.data
          new_message['is_user'] = !this.isOperator
          new_message['text'] = this.message
          new_message['files'] = fileObjs
          new_message['user_login'] = this.userLogin
          this.messages.push(new_message)
          this.$refs.form.reset()
          this.searchDialog = false
        } catch (e) {
          const err = e
          this.searchDialog = false
          if (e.response.status == 401 || e.response.status == 403) {
            await this.$store.dispatch('user/authLogOut')
            location.href = location.href
          }
          let error = 'Не удалось сохранить сообщение'
          await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
          console.error(e)
        }
      }
    },
    saveFile: function() {
      downloadFile({ 'data': _base64ToArrayBuffer(this.ticket['file']) }, `Заявка №${this.ticket['code']}.docx`, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
    },
    downloadMessageFile: function(msg_id, index) {
      try {
        var mime = require('mime-types')
        let fileType = this.messages[msg_id]['files'][index]['name'].split('.')[this.messages[msg_id]['files'][index]['name'].split('.').length - 1]
        let mimeType = mime.lookup(fileType)
        downloadFile({ 'data': _base64ToArrayBuffer(this.messages[msg_id]['files'][index]['file']) }, this.messages[msg_id]['files'][index]['name'], mimeType)
      } catch (e) {
        console.log(e)
      }
    },
    sortFunc: function(a, b) {
      let aDate = new Date(parseDate(a.date))
      let bDate = new Date(parseDate(b.date))
      if (aDate < bDate) {
        return 1
      }
      if (aDate > bDate) {
        return -1
      }
      if (a.code > b.code) {
        return -1
      }
      if (a.code < b.code) {
        return 1
      }
      return 0
    },
    customSort: function(items, index, isDescending) {
      let self = this
      items.sort(function(a, b) {
        if (!isDescending[0]) {
          return self.sortFunc(a, b)
        } else {
          return self.sortFunc(b, a)
        }
      })
      return items
    }
  }
}

</script>
<style scoped>
a {
  text-decoration: none;
  color: #101010;
}

a:hover,
a:hover>.v-icon {
  color: orange;
}

.round-icon {
  color: white;
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-size: 20pt;
  height: 70px;
}

.round-icon-back {
  margin-top: 10px;
  margin-bottom: -20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 70px;
  width: 70px;
  border-radius: 50%;
  background-color: #005caf;
}

.message-input .v-input__slot {
  border-style: none !important;
}

.message-file {
  font-size: 10pt;
  color: #005caf;
  text-decoration: underline;
  cursor: pointer;
}

.msg-text {
  white-space: pre-wrap;
}

</style>
